import React from 'react';
import { PageHeader, PageHeaderProps } from 'antd';

import './AccountPageHeader.less';

type AccountPageHeaderProps = {
  children?: React.ReactNode
}

type IAccountPageHeaderProps = AccountPageHeaderProps & PageHeaderProps

export function AccountPageHeader(props: IAccountPageHeaderProps) {
  return (
    <PageHeader
      {...props}
      className="account-page-header"
    >
      {props.children}
    </PageHeader>
  );
}
